import { Tooltip } from "antd";
import { toast } from "react-toastify";
import AppSecureStorage from "../services/secureStorage";
import CryptoJS from "crypto-js";

export const formatTime = (timestamp) => {
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return "Invalid Time";
    }

    // Formatting time in "h:mm A" format (e.g., 6:30 PM)
    return date
      .toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        hourCycle: "h24", // Use 24-hour format for compatibility
      })
      .toUpperCase();
  } catch (error) {
    return "Error";
  }
};
export const addDateAndTime = (timestamps) => {
  let previousDate = null;
  let timestampWithDay = [];
  timestamps?.forEach((timestampObj) => {
    let timestamp = new Date(timestampObj.timestamp);
    let currentDate = timestamp.toLocaleDateString("en-Us", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

    if (currentDate !== previousDate) {
      let currentDay = timestamp.toLocaleString("en-Us", { weekday: "long" });
      let dayWithDate = `${currentDate}, ${currentDay}`;
      timestampWithDay.push({
        day: dayWithDate,
        timestamp: timestampObj.timestamp,
        sentby: "manually",
      });
    }
    timestampWithDay.push(timestampObj);
    previousDate = currentDate;
  });
  return timestampWithDay;
};

export const flattenObject = (obj, parentKey = "") => {
  let result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key; // Corrected interpolation
      if (typeof obj[key] === "object" && obj[key] !== null) {
        Object.assign(result, flattenObject(obj[key], newKey));
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};
const storage = new AppSecureStorage();
export const unauthorizedError = (navigate) => {
  // toast.info("App is deactivated");
  navigate("/");
  storage.clearAuthData();
};

export const sortData = (data, key, direction) => {
  if (!Array.isArray(data)) {
    return [];
  }

  const sortedData = [...data];
  sortedData.sort((a, b) => {
    let aValue =
      key === "permissions" ? Object.keys(a[key] || {}).join(", ") : a[key];
    let bValue =
      key === "permissions" ? Object.keys(b[key] || {}).join(", ") : b[key];

    if (key === "verified") {
      aValue = a.verified ? "Verified" : "Unverified";
      bValue = b.verified ? "Verified" : "Unverified";
    }

    if (typeof aValue === "number" && typeof bValue === "number") {
      return direction === "asc" ? aValue - bValue : bValue - aValue;
    } else {
      return direction === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }
  });
  return sortedData;
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  const endDate = `${year}-${month}-${day}`;

  return endDate;
};

export const formatDateUTC = (date) => {
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");

  const endDate = `${year}-${month}-${day}`;

  return endDate;
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  return formatDate(currentDate);
};
export const truncateWithTooltip = (text, maxLength = 20) => {
  if (!text || text.length <= maxLength) return text;
  return (
    <Tooltip title={text} placement="topLeft">
      <span className="group-name-text">
        {`${text.substring(0, maxLength)}...`}
      </span>
    </Tooltip>
  );
};
export const getOrgId = () => {
  const orgId = storage.get("orgId");
  return orgId;
};

const ENCRYPTION_PRIVATE_KEY = process.env.REACT_APP_ENCRYPTION_PRIVATE_KEY;
const ENCRYPTION_INITIALISATION_VECTOR = process.env.REACT_APP_ENCRYPTION_INITIALISATION_VECTOR;

export function encryptData(data) {
  const jsonData = JSON.stringify(data);
  const key = CryptoJS.enc.Hex.parse(ENCRYPTION_PRIVATE_KEY);
  const iv = CryptoJS.enc.Hex.parse(ENCRYPTION_INITIALISATION_VECTOR);
  const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}
